import { render, staticRenderFns } from "./SentimentIndex.vue?vue&type=template&id=3c89a1a7&scoped=true&"
import script from "./SentimentIndex.vue?vue&type=script&lang=js&"
export * from "./SentimentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89a1a7",
  null
  
)

export default component.exports